<template>
  <div
    ref="selectFrame"
    class="csv-uploader"
    :class="{ 'file-drag-on': isFileDragOn }"
    @drop="onFileChanged($event)"
  >
    <v-file-input
      v-model="files"
      type="file"
      ref="fileInput"
      class="d-none"
      accept=".csv"
      @change="onFileChanged($event)"
    />
    <div>
      <div
        v-if="files && !hasError"
        class="subtitle-3 mb-1"
      >
        {{ fileName }}
      </div>
      <div class="text-body-3 neutral-043--text">
        {{ $t('translation.DROP_FILE_HERE_OR') }}
        <span
          @click="clickUploadButton"
          class="text-body-2 primary-001--text mt-1"
          style="cursor: pointer"
        >
          {{ $t('translation.SELECT_FILE') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import papaparse from 'papaparse';

export default {
  name: '',
  props: {
    requireColumns: {
      type: Array,
      default: () => []
    },
    propsFile: {
      type: File,
      default: () => (null)
    }
  },
  data() {
    return {
      files: null,
      isFileDragOn: false,
      hasError: false,
      fileName: ''
    };
  },
  watch: {
    propsFile(val) {
      this.files = val;
      if (!val) {
        this.fileName = '';
      }
    },
    files(val) {
      this.$emit('update:propsFile', val);
    }
  },
  mounted() {
    this.$refs.selectFrame.ondragleave = (e) => {
      e.preventDefault();
      this.isFileDragOn = false;
    };
    this.$refs.selectFrame.ondrop = (e) => {
      e.preventDefault();
      this.isFileDragOn = false;
    };
    this.$refs.selectFrame.ondragenter = (e) => {
      e.preventDefault();
      this.isFileDragOn = true;
    };
    this.$refs.selectFrame.ondragover = (e) => {
      e.preventDefault();
      this.isFileDragOn = true;
    };
  },
  methods: {
    clickUploadButton() {
      this.$refs.fileInput.$refs.input.click();
    },
    checkRequireHeaders(columns) {
      const result = {
        isValid: true,
        missedColumn: []
      };
      this.requireColumns.forEach((column) => {
        if (!columns.includes(column)) {
          result.missedColumn.push(column);
          result.isValid = false;
        }
      });
      return result;
    },
    onFileChanged(event) {
      const vm = this;
      if (typeof event === 'undefined') return;
      if (event.dataTransfer) {
        this.files = event.dataTransfer.files[0];
      }

      papaparse.parse(this.files, {
        header: true,
        complete: (results) => {
          const checkResult = vm.checkRequireHeaders(results.meta.fields);

          if (checkResult.isValid) {
            vm.importErrorMsg = '';
            vm.hasError = false;
            vm.fileName = vm.files.name;
            vm.$emit('csv-uploaded', results.data);
          } else {
            vm.hasError = true;
            vm.fileName = '';
            vm.files = null;
            vm.$emit('csv-upload-error', `${vm.$t('translation.CSV_REQUIRED_COLUMN')} ${checkResult.missedColumn.join(', ')}`);
          }
        }
      });
    },
    resetCsvUploader() {
      this.files = null;
      this.fileName = null;
      this.hasError = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.csv-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px $neutral-cold-054 dashed;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  text-align: center;
}

.file-drag-on {
  border: 2px dashed #608FFF;
}
</style>
